import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { Banner } from "./Banner";
import { Cta } from "./Cta";
const Footer = (props) => {
    const { configProperties, item } = props;
    return (_jsxs("div", Object.assign({ className: cx("item-footer", "footer") }, { children: [(isNotUndefinedOrNull(item.banner) && isNotUndefinedOrNull(item.banner.enabled) && item.banner.enabled)
                ?
                    _jsx("div", Object.assign({ className: "banner" }, { children: _jsx(Banner, { item: item }) }))
                : _jsx(_Fragment, {}), _jsx("div", Object.assign({ className: "title" }, { children: _jsx("div", { dangerouslySetInnerHTML: { "__html": item.title } }) })), _jsx("div", { className: "price analytics-pricing-bottom", dangerouslySetInnerHTML: { "__html": item.price } }), _jsx("div", Object.assign({ className: "cta1" }, { children: _jsx("div", Object.assign({ className: `cta1-${item.ctaOne.type}` }, { children: _jsx(Cta, { configProperties: configProperties, ctaData: item.ctaOne }) })) }))] })));
};
export { Footer };
